import { ChevronRight } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { useDialog } from 'common/hooks/useDialog';
import { formatCurrency } from 'common/utils/formatUtils';
import { FinancialReserveFragment } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

import {
  FinancialReserveDetailDialog,
  FinancialReserveDetailDialogProps,
} from '../FinancialReserveDetailDialog/FinancialReserveDetailDialog';
import { styles } from './FinancialReserveListItem.styles';

export interface FinancialReserveListItemProps {
  financialReserve: FinancialReserveFragment;
}

export const FinancialReserveListItem: React.FC<FinancialReserveListItemProps> = ({ financialReserve }) => {
  const { i18n } = useTranslation();

  const financialReserveDetailDialog = useDialog<FinancialReserveDetailDialogProps, void>(
    FinancialReserveDetailDialog,
    {
      id: financialReserve.id,
      instanceId: `edit-financial-reserve-${financialReserve.id}`,
      navigable: true,
    },
  );

  const handleFinancialReserveListItemClick = async () => {
    await financialReserveDetailDialog.create({ id: financialReserve.id });
  };

  return (
    <Box onClick={handleFinancialReserveListItemClick} sx={styles.clickableRow}>
      <Stack direction="row" flexGrow={1} justifyContent="space-between">
        <Typography variant="bodyL">{financialReserve.text}</Typography>
        <Typography color={'textSecondary'} variant="bodyL">
          {formatCurrency(financialReserve.amount.amount ?? 0, i18n.language)}
        </Typography>
      </Stack>
      <ChevronRight sx={styles.icon} />
    </Box>
  );
};
